import React from "react";
import SkillsImg from "../../Images/OurWork/health.png";
import WhyNdImg from "../../Images/OurWork/top-view-people-caring-mother-nature.jpg";
import skills from "../../Images/Home/skills.png";
import environment from "../../Images/Home/environment.png";
import woman from "../../Images/Home/woman.png";
import nd from "../../Images/Home/nd.png";

const WhyND = () => {
  return (
    <section className="relative text-white text-xl  md:py-10  bg-white ">
      <div
        className="absolute inset-0 z-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${WhyNdImg})` }}
      ></div>
      <div className="absolute inset-0 z-0  bg-ndlogoBlue opacity-80"></div>
      <div className="relative z-10 w-[95%] md:w-full  lg:w-[95%] mx-auto lg:px-4 py-10  gap-8">
        <h2 className="text-2xl md:text-4xl font-semibold text-center mb-6 font-edu-sa ">
          Why New Directions?
        </h2>
        <div className="flex flex-wrap justify-around gap-10 md:gap-2 lg:gap-7 md:px-6 pt-6 md:pt-12 ">
          {/* ********************************** Card 1 ********************************** */}

          <div className="relative bg-white text-black w-full md:w-[30%] rounded-lg shadow-lg p-6 scale-100 hover:scale-105 transition-transform duration-300">
            <div className="flex justify-center absolute -top-8 md:-top-10  left-1/2 -translate-x-1/2">
              <div className="bg-Orange text-white  h-14 w-14 md:w-20 md:h-20 rounded-full flex items-center justify-center">
                <img
                  src={environment}
                  alt="Environment"
                  className=" w-10 md:w-12  h-10 md:h-12"
                />
              </div>
            </div>

            <p className="text-base pt-5 leading-relaxed text-mediumGray">
              India today stands at a crossroads—facing pressing challenges
              across environment, employment, gender equity, and elder care.
              Carbon emissions, energy insecurity, and global warming continue
              unabated due to a lack of public awareness, stalling the
              transition to sustainable living.
            </p>
          </div>

          {/* ********************************** Card 2 ***********************************/}
          <div className="relative  bg-white text-black w-full md:w-[30%] rounded-lg shadow-lg p-6 scale-100 hover:scale-105 transition-transform duration-300">
            <div className="flex justify-center absolute  -top-8 md:-top-10 left-1/2 -translate-x-1/2">
              <div className="bg-Orange h-14 w-14 md:w-20 md:h-20 rounded-full flex items-center justify-center">
                <img
                  src={woman}
                  alt="Women Empowerment"
                  className="w-12 h-12"
                />
              </div>
            </div>

            <p className="text-base pt-5 leading-relaxed text-mediumGray">
              In rural India, women face systemic wage and mobility barriers,
              limiting their access to opportunity. Meanwhile, India’s rapidly
              aging population lacks structured care systems, leading to
              isolation and vulnerability.
            </p>
          </div>

          {/* ********************************** Card 3 ********************************** */}

          <div className="relative bg-white text-black w-full md:w-[30%] rounded-lg shadow-lg p-6 scale-100 hover:scale-105 transition-transform duration-300">
            <div className="flex justify-center absolute  -top-8 md:-top-10 left-1/2 -translate-x-1/2">
              <div className="bg-Orange  h-14 w-14 md:w-20 md:h-20 rounded-full flex items-center justify-center">
                <img
                  src={skills}
                  alt="Skill Development"
                  className="w-12 h-12 text-white"
                />
              </div>
            </div>

            <p className="text-base pt-5 leading-relaxed text-mediumGray">
              Over 50% of graduates remain unemployed, not for lack of
              education, but due to a skills mismatch that undermines both
              individual potential and national growth.
            </p>
          </div>

          {/* ********************************** Card 4 ******************************* */}

          <div className="relative bg-white  md:mt-10 text-black w-full md:w-full rounded-lg shadow-lg p-6 scale-100 hover:scale-105 transition-transform duration-300">
            <div className="flex justify-center absolute  -top-8 md:-top-10 left-1/2 -translate-x-1/2">
              <div className="bg-Orange h-14 w-14 md:w-20 md:h-20 rounded-full flex items-center justify-center">
                <img
                  src={nd}
                  alt="Skill Development"
                  className="w-12 h-12 text-white"
                />
              </div>
            </div>

            <p className="text-base pt-5  leading-relaxed text-mediumGray">
              New Directions was founded to confront these intersecting issues
              with integrated, impact-driven solutions—through skill
              development, women empowerment, climate action, and elder care
              initiatives. By bridging awareness, access, and opportunity, we
              are creating sustainable pathways for inclusive growth and social
              equity.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyND;
